import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getAccidents({ commit }, { paginate, query }) {
        commit('GET_ACCIDENTS_REQUEST')

        return axios
            .get(`/accidents/accidents${paginate}${query}`)
            .then(response => {
                commit('GET_ACCIDENTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_ACCIDENTS_FAILURE')
                handleApiError(error, 'Pobranie listy awarii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAccident(context, accidentId) {
        return axios
            .get(`/accidents/accidents/${accidentId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do awarii ${accidentId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    getAccidentTypes({ commit }) {
        return axios
            .get('/accidents/accidents/dicts/types')
            .then(response => {
                commit('GET_ACCIDENT_TYPES', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów awarii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAccidentStatuses({ commit }) {
        return axios
            .get('/accidents/accidents/dicts/statuses')
            .then(response => {
                commit('GET_ACCIDENT_STATUSES', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAccidentStatusHistory(context, accidentId) {
        return axios
            .get(`/accidents/accidents/${accidentId}/status-history`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie historii statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMachines({ commit }, {
        query = ''
    } = {}) {
        return axios
            .get(`/machines/machines${query}`)
            .then(response => {
                commit('GET_MACHINES', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie maszyn nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAccidentDepartments({ commit }) {
        return axios
            .get('/accidents/accidents/dicts/departments')
            .then(response => {
                commit('GET_ACCIDENT_DEPARTMENTS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie działów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAccidentUserDepartments({ commit }) {
        return axios
            .get('/accidents/accidents/dicts/departments-filter')
            .then(response => {
                commit('GET_ACCIDENT_USER_DEPARTMENTS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie działów użytkownika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createAccident({ commit }, accidentData) {
        commit('CREATE_ACCIDENT_REQUEST')

        return axios
            .post('/accidents/accidents', accidentData)
            .then(response => {
                commit('CREATE_ACCIDENT_SUCCESS', response.data)
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Awaria została dodana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('CREATE_ACCIDENT_FAILURE')
                handleApiError(error, 'Dodanie awarii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateAccident({ commit }, accidentData) {
        return axios
            .put(`/accidents/accidents/${accidentData.id}`, accidentData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Awaria została zedytowana.'
                }, { root: true })

                commit('UPDATE_ACCIDENT', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja awarii nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteAccident(context, id) {
        return axios
            .delete(`/accidents/accidents/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie awarii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createAccidentComment({ commit }, payload) {
        return axios
            .post('/accidents/accident-comments', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano komentarz.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie komentarza nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateAccidentsReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/accidents/accidents?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setAccidentsFilters({ commit }, filters) {
        commit('SET_ACCIDENTS_FILTERS', filters)
    },
    clearAccidentsFilters({ commit }) {
        commit('CLEAR_ACCIDENTS_FILTERS')
    }
}